import { useMemo } from 'react'

import { NetworkInterfaceData } from '../hooks/useNodeMonitorData'
import { DualLineChart } from './DualLineChart'

const BANDWIDTH_LABELS = { primary: 'TX', secondary: 'RX' } as const

interface BandwidthChartProps {
  interfaces: NetworkInterfaceData[]
  selectedInterfaces: string[]
  filterDuration: number
}

export function BandwidthChart({
  interfaces,
  selectedInterfaces,
  filterDuration,
}: BandwidthChartProps) {
  const data = useMemo(
    () =>
      interfaces.map((i) => ({
        name: i.name,
        primaryValues: i.txValues,
        secondaryValues: i.rxValues,
        isEmpty: i.isEmpty,
      })),
    [interfaces],
  )

  return (
    <DualLineChart
      data={data}
      selectedItems={selectedInterfaces}
      labels={BANDWIDTH_LABELS}
      filterDuration={filterDuration}
    />
  )
}
